import React from 'react';
import { Helmet } from 'react-helmet';

const tourData = [

  {
    title: " Aura",
    image: "/images/ourfleet/8.jpg",
    seater: "4+1",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Swift Desire",
    image: "/images/ourfleet/1.jpg",
    seater: "4+1",
    driverAllowance: "₹500",
    perKm: "₹12",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Verna",
    image: "/images/ourfleet/8.jpg",
    seater: "4+1",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Ertiga",
    image: "/images/ourfleet/2.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹15",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Innova Crysta ",
    image: "/images/ourfleet/3.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹20",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Kia Carens",
    image: "/images/ourfleet/4.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹17",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Innova Cab ",
    image: "/images/ourfleet/5.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Tempo Traveller",
    image: "/images/ourfleet/6.jpg",
    seater: "17",
    driverAllowance: "₹500",
    perKm: "₹25",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Luxury Bus",
    image: "/images/ourfleet/7.jpg",
    seater: "35",
    driverAllowance: "₹500",
    perKm: "On Call",
    extraHr: "₹150",
    nightHalt: "₹250",
  },


];

const Booking = () => {
  const handleBookNow = (tourTitle) => {
    const phoneNumber = "+917620911746";
    const message = `I want to Book ${tourTitle} With Skyline Cabs. Request you Please Send More Details or Call Me. Thank you. `;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };



  return (
    <>
     
     <section
    className="bg-cover position-relative"
    style={{
      background: 'url(/img/bg-title.jpg) no-repeat',
    }}
    data-overlay="5"
  >
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-xl-7 col-lg-9 col-md-12">
          <div className="fpc-capstion text-center my-4">
            <div className="fpc-captions">
              <h1 className="xl-heading text-light">Booking</h1>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


      {/* <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Online Booking</h1>
          </div>
        </div>
      </section> */}

      <section className="space">
        <div className="container">
          <div className="row">
            {tourData.map((tour, index) => (
              <div key={index} className="col-md-4 py-4">
                <div className="tour-box th-ani">
                  <div className="tour-box_img global-img ">
                    <img src={tour.image} alt={tour.title} />
                  </div>
                  <div className="tour-content bg-darkk">
                    <h3 className="box-title">
                      <h4 href={tour.detailLink} className="darkcolor text-center">{tour.title}</h4>
                    </h3>
                    <div className="tour-details">
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Seater:</strong></span>
                        <span className="detail-value">{tour.seater.replace('+', ' + ')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Per Km:</strong></span>
                        <span className="detail-value">{tour.perKm.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Extra Hr:</strong></span>
                        <span className="detail-value">{tour.extraHr.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Night Halt:</strong></span>
                        <span className="detail-value">{tour.nightHalt.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                    </div>

                    <div className="tour-action text-center">
                      <button
                        onClick={() => handleBookNow(tour.title)}
                        className="btn btn-primary "
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
